import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");

Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.debug = true;



// WEBPACK FOOTER //
// ./src/main.js